<template lang="pug">
    .native-warning-wrapper
        .native-warning(v-if="showed && !closed") 
            .warning-text WARNING! TRACKING SERVICE IS NOT RESPONSIVE
            .warning-close(@click="close()") ⨯
</template>

<script>
import Screen from './../../mixins/screen'
import { Tracking } from './../../services/Tracking'

export default {
    name: "NativeTrackingWarning",
    mixins: [Screen],
    screen: {
        events: {
            'Tracking Avaibility Status Changed': function(isAvailable) {
                this.showed = !isAvailable;
            }
        }
    },
    data() {
        Tracking.getAvaibility( isAvailable => showed = User.currentUser && User.currentUser.isAdmin && !isAvailable );
        return {
            showed: false,
            closed: false
        };
    },
    computed: {
    },
    methods: {
        close() {
            this.closed = true;
        }
    }
}
</script>

<style lang="sass">
    .native-warning-wrapper
        position: fixed
        top: 30px
        display: flex
        width: 100vw
        z-index: 10000
        justify-content: center

    .native-warning
        background-color: var(--danger)
        text-align: center
        display: flex
        gap: 7px
        width: fit-content
        padding: .35rem .65rem
        border-radius: .375rem
        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15), 0 3px 5px rgba(0, 0, 0, 0.05), 0 3px 5px rgba(0, 0, 0, 0.05)
        
    .warning-close
        cursor: pointer
        color: var(--white)
        font-size: 1.2rem
        line-height: 1.1rem

    .warning-text
        color: var(--white)
</style>
